import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isNotNil } from 'ramda';
var MEASUREMENTS = [{
  title: {
    i18n_key: 'client:measurement.liverGallbladderBlood',
    text: '肝膽功能檢查-血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.ast_got',
      text: '血清麩胺酸苯醋酸轉氨基脢'
    },
    value: 'ast_got',
    gte: 8,
    lte: 39,
    detail: '8-39 U/L',
    unit: 'U/L'
  }, {
    title: {
      i18n_key: 'client:measurement.alt_gpt',
      text: '血清麩胺酸丙酮酸轉氨基脢'
    },
    value: 'alt_gpt',
    gte: 0,
    lte: 41,
    detail: '<41 U/L',
    unit: 'U/L'
  }, {
    title: {
      i18n_key: 'client:measurement.bilirubin_total',
      text: '膽紅素總量'
    },
    value: 'bilirubin_total',
    gte: 0.3,
    lte: 1,
    detail: '',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.bilirubin_direct',
      text: '直接膽紅素'
    },
    value: 'bilirubin_direct',
    gte: 0.03,
    lte: 0.18,
    detail: '',
    unit: 'mg/dL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.kidneyTest',
    text: '腎功能檢查'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.blood_creatinine',
      text: '血液肌酸酐'
    },
    value: 'blood_creatinine',
    gte: 0.6,
    lte: 1.3,
    detail: '0.6-1.3 mg/dL',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.egfr',
      text: '腎絲球過濾速率'
    },
    value: 'egfr',
    detail: "\n                Stage 1: \u226790 mL / min / 1.73 m2 Kidney damage(e.g.protein in the urine) with normal eGFR ; \n\n                Stage 2: 60 - 89 mL/ min / 1.73 m2 Kidney damage with mild decrease in eGFR ; \n\n                Stage 3a: 45-59 mL/ min / 1.73 m2 Moderate decrase in eGFR ; \n\n                Stage 3b: 30 - 44 mL / min / 1.73 m2 Moderate decrease in eGFR; \n\n                Stage 4: 15 - 29 mL / min / 1.73 m2 Severe reduction in eGFR; \n\n                Stage 5: Less than 15 mL / min / 1.73 m2 Kidney failure,",
    unit: 'ml/min/1.73m2'
  }, {
    title: {
      i18n_key: 'client:measurement.uric_acid',
      text: '尿酸'
    },
    value: 'uric_acid',
    male: {
      gte: 4.4,
      lte: 7.6
    },
    female: {
      gte: 2.3,
      lte: 6.6
    },
    unit: 'mg/dL',
    detail: 'F:2.3-6.6 mg/dL ;\n M:4.4-7.6 mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.Microalbumin',
      text: '尿液微量白蛋白'
    },
    value: 'Microalbumin',
    unit: 'mg/dL',
    detail: {
      i18n_key: 'client:measurement.Microalbumin_details',
      text: '隨機尿：< 1.9 mg/dL； \n    Normal：< 30 mg/24hr'
    }
  }, {
    title: {
      i18n_key: 'client:measurement.urine_creatine',
      text: '尿液肌酸酐'
    },
    value: 'urine_creatine',
    unit: '',
    detail: ''
  }, {
    title: {
      i18n_key: 'client:measurement.uacr',
      text: 'UACR'
    },
    value: 'uacr',
    gte: 0,
    lte: 30,
    unit: 'mg/g',
    detail: ''
  }]
}, {
  title: {
    i18n_key: 'client:measurement.bloodGlucoseSpecimenBlood',
    text: '血糖-檢體:血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.glucose_ac',
      text: '飯前血糖'
    },
    value: 'glucose_ac',
    gte: 60,
    lte: 87,
    detail: {
      i18n_key: 'client:measurement.glucose_ac_details',
      text: "1. \u4F9D\u64DA\u885B\u751F\u798F\u5229\u90E8\u570B\u6C11\u5065\u5EB7\u7F72\u6162\u6027\u75BE\u75C5\u9632\u6CBB\u7D44\u8840\u7CD6\u53C3\u8003\u6A19\u6E96\uFF1A \n    \u7A7A\u8179\u8840\u7CD6\u503C\u4E4B\u5B9A\u7FA9\uFF1A\n   \uFF1C100 \u6B63\u5E38 ;    100\uFF5E125 \u7CD6\u5C3F\u75C5\u524D\u671F ;    \uFF1E126 \u7CD6\u5C3F\u75C5\n\n               2. \u2266 40 \u6216 \u2267 500 mg / dL \u9700\u505A\u5371\u96AA\u503C\u901A\u5831\u4E26\u7D00\u9304\u4E4B"
    },
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.glucose_pc_1hr',
      text: '耐糖試驗60分鐘'
    },
    value: 'glucose_pc_1hr',
    gte: 60,
    lte: 190,
    detail: '',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.glucose_pc_2hr',
      text: '飯後血糖'
    },
    value: 'glucose_pc_2hr',
    gte: 80,
    lte: 140,
    detail: {
      i18n_key: 'client:measurement.glucose_pc_2hr_details',
      text: "1. \u4F9D\u64DA\u885B\u751F\u798F\u5229\u90E8\u570B\u6C11\u5065\u5EB7\u7F72\u6162\u6027\u75BE\u75C5\u9632\u6CBB\u7D44\u8840\u7CD6\u53C3\u8003\u6A19\u6E96\uFF1A \n    \u7A7A\u8179\u8840\u7CD6\u503C\u4E4B\u5B9A\u7FA9\uFF1A\n   \uFF1C100 \u6B63\u5E38 ;   100\uFF5E125 \u7CD6\u5C3F\u75C5\u524D\u671F ;   \uFF1E126 \u7CD6\u5C3F\u75C5\n\n               2. \u2266 40 \u6216 \u2267 500 mg / dL \u9700\u505A\u5371\u96AA\u503C\u901A\u5831\u4E26\u7D00\u9304\u4E4B\n"
    },
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.homa_ir',
      text: '胰島素阻抗值'
    },
    value: 'homa_ir',
    gte: 0,
    lte: 1.4,
    detail: {
      i18n_key: 'client:measurement.homa_ir_details',
      text: '＞1.0-1.4 輕度胰島素組抗； \n    1.4-2.6 中度胰島素組抗；＞2.6 高度胰島素組抗 [空腹]'
    },
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.homa_beta',
      text: 'β細胞功能'
    },
    value: 'homa_beta',
    gte: 50,
    lte: 300,
    detail: "",
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.hba1c',
      text: '醣化血色素'
    },
    value: 'hba1c',
    gte: 0,
    lte: 5.7,
    detail: "",
    unit: '%'
  }]
}, {
  title: '血脂肪/心血管檢查-血液',
  data: [{
    title: {
      i18n_key: 'client:measurement.triglyceride',
      text: '三酸甘油脂'
    },
    value: 'triglyceride',
    gte: 30,
    lte: 150,
    detail: "",
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.total_cholesterol',
      text: '總膽固醇'
    },
    value: 'total_cholesterol',
    gte: 0,
    lte: 200,
    detail: '',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.high_density_lipoprotein',
      text: '高密度脂蛋白-膽固醇'
    },
    value: 'high_density_lipoprotein',
    male: {
      gte: 40
    },
    female: {
      gte: 50
    },
    detail: {
      i18n_key: 'client:measurement.high_density_lipoprotein_details',
      text: "\u8AAA\u660E\uFF1A \n    \n                  1. <40 mg/dL \u70BA\u51A0\u5FC3\u75C5\u7684\u9AD8\u5EA6\u98A8\u96AA\u56E0\u7D20 \n    \n                  2. \u226760 mg/dL \u70BA\u51A0\u5FC3\u75C5\u7684\u7121\u98A8\u96AA\u56E0\u7D20"
    },
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.low_density_lipoprotein_cholesterol',
      text: '低密度脂蛋白'
    },
    value: 'low_density_lipoprotein_cholesterol',
    gte: 0,
    lte: 130,
    detail: '',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.ldl_hdl_raio',
      text: '低密度脂蛋白/高密度脂蛋白_生化法'
    },
    value: 'ldl_hdl_raio',
    male: {
      gte: 0,
      lte: 3.5
    },
    female: {
      gte: 0,
      lte: 3.22
    },
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.tcho_hdl_ratio',
      text: '膽固醇/高密度脂蛋白_生化法'
    },
    value: 'tcho_hdl_ratio',
    gte: 0,
    lte: 5,
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.tg_hdl_ratio',
      text: '三酸甘油脂/高密度脂蛋白'
    },
    value: 'tg_hdl_ratio',
    gte: 0,
    lte: 2.5,
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.homocysteine',
      text: '同半胱胺酸'
    },
    value: 'homocysteine',
    gte: 5,
    lte: 15,
    detail: '> 60 years: 5-20 umol/L',
    unit: 'umol/L'
  }, {
    title: {
      i18n_key: 'client:measurement.sd_ldl',
      text: '超壞低密度膽固醇'
    },
    value: 'sd_ldl',
    gte: 12.6,
    lte: 51.7,
    detail: {
      i18n_key: 'client:measurement.sd_ldl_details',
      text: "\u7537\u6027(21-44 \u6B72)\uFF1A12.7-48.3 mg/dL; \n    \n              \u5973\u6027(21-54 \u6B72)\uFF1A12.7-48.3 mg/dL; \n    \n              \u7537\u6027(45-75 \u6B72)\uFF1A12.6-51.7 mg/dL; \n    \n              \u5973\u6027(55-75 \u6B72)\uFF1A12.6-51.7 mg/dL; \n    \n              Cut-off value for CHD: 50.0 mg/dL"
    },
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.apoli_a1',
      text: '載脂蛋白A1'
    },
    value: 'apoli_a1',
    gte: 100,
    lte: 200,
    detail: "",
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.apoli_b',
      text: '載脂蛋白B'
    },
    value: 'apoli_b',
    gte: 50,
    lte: 155,
    detail: "",
    unit: 'mg/dL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.bloodTest',
    text: '血液學檢查'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.wbc',
      text: '白血球'
    },
    value: 'wbc',
    gte: 4,
    lte: 10.8,
    detail: '',
    unit: '10^3/uL'
  }, {
    title: {
      i18n_key: 'client:measurement.neutrophils',
      text: '中性球'
    },
    value: 'neutrophils',
    gte: 40,
    lte: 75,
    detail: '',
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.lymphocytes',
      text: '淋巴球'
    },
    value: 'lymphocytes',
    gte: 20,
    lte: 50,
    detail: '',
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.monocytes',
      text: '單核球'
    },
    value: 'monocytes',
    gte: 3.4,
    lte: 11,
    detail: '',
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.eosinophils',
      text: '嗜伊紅白血球'
    },
    value: 'eosinophils',
    gte: 0,
    lte: 6.0,
    detail: '',
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.basophils',
      text: '嗜鹼性球'
    },
    value: 'basophils',
    gte: 0,
    lte: 1.4,
    detail: '',
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.rbc',
      text: '紅血球'
    },
    value: 'rbc',
    male: {
      gte: 4.5,
      lte: 6
    },
    female: {
      gte: 4,
      lte: 5.2
    },
    detail: '',
    unit: '10^6/uL'
  }, {
    title: {
      i18n_key: 'client:measurement.hb',
      text: '血紅素'
    },
    value: 'hb',
    male: {
      gte: 13.5,
      lte: 17.5
    },
    female: {
      gte: 11.5,
      lte: 15.5
    },
    detail: '',
    unit: 'g/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.hematocrit',
      text: '血球容積比'
    },
    value: 'hematocrit',
    male: {
      gte: 40.5,
      lte: 50.5
    },
    female: {
      gte: 35.0,
      lte: 45.0
    },
    detail: "Male\uFF1A40.5-50.5\uFF1B\n\n                    Female\uFF1A35.0-45.0   %",
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.esr',
      text: '紅血球沈降速度測定'
    },
    value: 'esr',
    lte: 20,
    detail: '<20 mm/hr',
    unit: 'mm/hr'
  }, {
    title: {
      i18n_key: 'client:measurement.mcv',
      text: '平均紅血球值'
    },
    value: 'mcv',
    gte: 80,
    lte: 99,
    detail: '',
    unit: 'fL'
  }, {
    title: {
      i18n_key: 'client:measurement.mch',
      text: '平均血色素量'
    },
    value: 'mch',
    gte: 27,
    lte: 34,
    detail: '',
    unit: 'pg'
  }, {
    title: {
      i18n_key: 'client:measurement.mchc',
      text: '平均色素濃度'
    },
    value: 'mchc',
    gte: 31,
    lte: 37,
    detail: '',
    unit: 'g/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.platelet',
      text: '血小板計數'
    },
    value: 'platelet',
    gte: 130,
    lte: 400,
    detail: '',
    unit: '10^3/uL'
  }, {
    title: {
      i18n_key: 'client:measurement.rdw_sd',
      text: '紅血球分佈寬度-標準差'
    },
    value: 'rdw_sd',
    gte: 36,
    lte: 46,
    detail: '',
    unit: 'fL'
  }, {
    title: {
      i18n_key: 'client:measurement.rdw_cv',
      text: '紅血球分佈寬度'
    },
    value: 'rdw_cv',
    detail: '',
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.monocytes_percent',
      text: '單核球數量'
    },
    value: 'monocytes_percent',
    detail: '',
    unit: '10*3 /uL'
  }, {
    title: {
      i18n_key: 'client:measurement.eosinophils_percent',
      text: '嗜酸性球數量'
    },
    value: 'eosinophils_percent',
    detail: '',
    unit: '10*3 /uL'
  }, {
    title: {
      i18n_key: 'client:measurement.basophils_percent',
      text: '嗜鹼性球數量'
    },
    value: 'basophils_percent',
    detail: '',
    unit: '10*3 /uL'
  }, {
    title: {
      i18n_key: 'client:measurement.ddimer',
      text: 'D-D 雙合試驗'
    },
    value: 'ddimer',
    gte: 0,
    lte: 0.5,
    detail: '(cut-off value for exclude PE and DVT < 0.5 ug/mL FEU)',
    unit: 'ug/mL FEU'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.thyroidScreeningBlood',
    text: '甲狀腺篩檢-血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.t3',
      text: '三碘甲狀腺素'
    },
    value: 't3',
    gte: 75,
    lte: 150,
    detail: {
      i18n_key: 'client:measurement.refAndIdeal',
      text: '參考值 75-150；理想值 90-130',
      vars: {
        ref: '75-150',
        ideal: '90-130'
      }
    },
    unit: 'ng/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.t3_free',
      text: '游離三碘甲狀腺素'
    },
    value: 't3_free',
    gte: 2.2,
    lte: 4.2,
    detail: {
      i18n_key: 'client:measurement.refAndIdeal',
      text: '參考值 2.2-4.2；理想值 2.7-3.7',
      vars: {
        ref: '2.2-4.2',
        ideal: '2.7-3.7'
      }
    },
    unit: 'pg/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.t3_reverse',
      text: '反三碘甲狀腺素'
    },
    value: 't3_reverse',
    gte: 11,
    lte: 30,
    detail: {
      i18n_key: 'client:measurement.refAndIdeal',
      text: '參考值 11-30；理想值 11-18',
      vars: {
        ref: '11-30',
        ideal: '11-18'
      }
    },
    unit: 'ng/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.t4',
      text: '甲狀腺素'
    },
    value: 't4',
    gte: 5,
    lte: 11,
    detail: {
      i18n_key: 'client:measurement.refAndIdeal',
      text: '參考值 5.0-11；理想值 6.5-9.0',
      vars: {
        ref: '5.0-11',
        ideal: '6.5-9.0'
      }
    },
    unit: 'ug/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.t4_free',
      text: '游離甲狀腺素'
    },
    value: 't4_free',
    gte: 0.9,
    lte: 1.7,
    detail: {
      i18n_key: 'client:measurement.refAndIdeal',
      text: '參考值 0.9-1.7；理想值 1.1-1.5',
      vars: {
        ref: '0.9-1.7',
        ideal: '1.1-1.5'
      }
    },
    unit: 'ng/dL'
  }, {
    title: '甲狀腺促進素 TSH',
    value: 'tsh',
    gte: 0.4,
    lte: 4.0,
    detail: {
      i18n_key: 'client:measurement.refAndIdeal',
      text: '參考值 0.4-4.0；理想值 0.4-2.0',
      vars: {
        ref: '0.4-4.0',
        ideal: '0.4-2.0'
      }
    },
    unit: 'uIU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.anti_tpo_ab',
      text: '甲狀腺過氧化酶抗體'
    },
    value: 'anti_tpo_ab',
    gte: 0,
    lte: 34,
    detail: {
      i18n_key: 'client:measurement.refAndIdeal',
      text: '參考值 0–34；理想值 0–10',
      vars: {
        ref: '0-34',
        ideal: '0-10'
      }
    },
    unit: 'IU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.anti_tshr',
      text: '甲促素結合體抗體'
    },
    value: 'anti_tshr',
    gte: 0,
    lte: 15,
    detail: "RIA: <15%\n\n                    ECLIA: <1.75 IU/L",
    unit: '%'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.urineTest',
    text: '尿液檢查'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.urine_appearance',
      text: '尿液外觀'
    },
    value: 'urine_appearance',
    whitelist: ['Colorless'],
    detail: "",
    unit: '',
    hideRangeBar: true
  }, {
    title: {
      i18n_key: 'client:measurement.urine_clarity',
      text: '尿液混濁度'
    },
    value: 'urine_clarity',
    whitelist: ['Clear'],
    detail: '',
    unit: '',
    hideRangeBar: true
  }, {
    title: {
      i18n_key: 'client:measurement.urine_spe_gravity',
      text: '尿液比重'
    },
    value: 'urine_spe_gravity',
    gte: 1.005,
    lte: 1.03,
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_ph',
      text: '尿酸鹼度'
    },
    value: 'urine_ph',
    gte: 5,
    lte: 8,
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_protein',
      text: '尿蛋白'
    },
    value: 'urine_protein',
    whitelist: ['- (<10 mg/dL)', '+/- (10 mg/dL)', '- (<15 mg/dL)', '+/- (15 mg/dL)', '+/- (20 mg/dL)', '- (<30 mg/dL)'],
    detail: '- (<30 mg/dL)',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.urine_glucose',
      text: '尿醣'
    },
    value: 'urine_glucose',
    whitelist: ['- (<30 mg/dL)', '+/- (30 mg/dL)', '- (<50 mg/dL)', '+/- (50 mg/dL)'],
    detail: '- (<50 mg/dL)',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.urine_bilirubin',
      text: '膽紅素'
    },
    value: 'urine_bilirubin',
    whitelist: ['- (<0.5 mg/dL)', '- (<2 mg/dL)'],
    detail: '- (<2 mg/dL)',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.urobilinogen',
      text: '尿膽原'
    },
    value: 'urobilinogen',
    whitelist: ['Normal (<1.5 mg/dL)', 'Normal (<2 mg/dL)', 'Normal (<2.0 mg/dL)'],
    detail: 'Normal (<2 mg/dL)',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.urine_ketones',
      text: '苯酮體'
    },
    value: 'urine_ketones',
    whitelist: ['- (<5 mg/dL)', '+/- (5 mg/dL)', '- (<10 mg/dL)', '+/- (<10 mg/dL)'],
    detail: '- (<5 mg/dL)',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.urine_blood',
      text: '尿潛血'
    },
    value: 'urine_blood',
    whitelist: ['- (<0.03 mg/dL)', '+/- (0.03 mg/dL)'],
    detail: '- (<0.03 mg/dL)',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.urine_leu',
      text: '白血球酯脢'
    },
    value: 'urine_leu',
    whitelist: ['- (<25 Leu/uL)', '- (<25 WBCs/uL)', '- (<25 c/uL)', '+/- (25 Leu/uL)', '+/- (25 WBCs/uL)'],
    detail: '- (<25 WBCs/uL)',
    unit: 'uL'
  }, {
    title: {
      i18n_key: 'client:measurement.urine_nitrite',
      text: '亞硝酸鹽'
    },
    value: 'urine_nitrite',
    whitelist: ['(-)'],
    detail: '(-)',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_wbc',
      text: '白血球'
    },
    value: 'urine_wbc',
    whitelist: ['0-5'],
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_rbc',
      text: '紅血球'
    },
    value: 'urine_rbc',
    whitelist: ['0-2'],
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_ep',
      text: '上皮細胞'
    },
    value: 'urine_ep',
    whitelist: ['0-5'],
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_other',
      text: '其他'
    },
    value: 'urine_other',
    whitelist: ['Not Found'],
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_cas',
      text: '圓柱體'
    },
    value: 'urine_cas',
    whitelist: ['Not Found'],
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_bac',
      text: '細菌'
    },
    value: 'urine_bac',
    whitelist: ['Not Found'],
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.urine_cry',
      text: '結晶體'
    },
    value: 'urine_cry',
    whitelist: ['Not Found'],
    detail: '',
    unit: ''
  }]
}, {
  title: {
    i18n_key: 'client:measurement.cancerScreeningBlood',
    text: '腫瘤篩檢-血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.psa',
      text: '攝護腺特異抗原'
    },
    value: 'psa',
    gte: 0,
    lte: 4.9,
    detail: "",
    unit: 'ng/mL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.pancreasScreening',
    text: '胰臟篩檢'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.amylase',
      text: '澱粉脢'
    },
    value: 'amylase',
    gte: 29,
    lte: 103,
    detail: "",
    unit: 'U/L'
  }, {
    title: {
      i18n_key: 'client:measurement.lipase',
      text: '解脂脢'
    },
    value: 'lipase',
    gte: 11,
    lte: 82,
    detail: '',
    unit: 'U/L'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.hormoneAnalysisBlood',
    text: '荷爾蒙分析-血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.prolactin',
      text: '催乳激素'
    },
    value: 'prolactin',
    male: {
      gte: 2.64,
      lte: 13.13
    },
    female: {
      gte: 3.34,
      lte: 26.72
    },
    detail: {
      i18n_key: 'client:measurement.prolactin_details',
      text: "\u5973\u6027(F):\u505C\u7D93\u524D(<50\u6B72)3.34-26.72 ; \u505C\u7D93\u5F8C(>50\u6B72):2.74-19.64 ng/mL\n\n        \u7537\u6027(M):2.64-13.13 ng/mL"
    },
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.fsh',
      text: '濾泡刺激素'
    },
    value: 'fsh',
    male: {
      gte: 1.5,
      lte: 12.4
    },
    female: {
      gte: 1.7,
      lte: 7.71
    },
    detail: {
      i18n_key: 'client:measurement.fsh_details',
      text: "-\u5973\u6027 (\u9EC3\u9AD4\u671F)\uFF1A(\u53C3\u8003\u503C 1.7-7.7\uFF1B\u7406\u60F3\u503C 1.7-5.0)\n\n              -\u5973\u6027 (\u6FFE\u6CE1\u671F)\uFF1A(\u53C3\u8003\u503C 3.5-12.5\uFF1B\u7406\u60F3\u503C 3.5-8.0)\n\n              -\u5973\u6027 (\u505C\u7D93\u5F8C)\uFF1A26-135\n\n              -\u7537\u6027\uFF1A(\u53C3\u8003\u503C 1.5-12.4\uFF1B\u7406\u60F3\u503C 1.5-6.0)"
    },
    unit: 'mIU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.lh',
      text: '黃體激素'
    },
    value: 'lh',
    male: {
      gte: 1.7,
      lte: 8.6
    },
    female: {
      gte: 1.0,
      lte: 11.4
    },
    detail: {
      i18n_key: 'client:measurement.lh_details',
      text: "-\u5973\u6027 (\u9EC3\u9AD4\u671F)\uFF1A(\u53C3\u8003\u503C 1.0-11.4\uFF1B\u7406\u60F3\u503C 1.0-6.2)\n\n              -\u5973\u6027 (\u6FFE\u6CE1\u671F)\uFF1A(\u53C3\u8003\u503C 2.4-12.6\uFF1B\u7406\u60F3\u503C 2.4-7.5)\n\n              -\u5973\u6027 (\u505C\u7D93\u5F8C)\uFF1A15-75\n\n              -\u7537\u6027\uFF1A(\u53C3\u8003\u503C 1.7-8.6\uFF1B\u7406\u60F3\u503C 1.7-5.0)"
    },
    unit: 'mIU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.e2',
      text: '雌二醇'
    },
    value: 'e2',
    male: {
      gte: 9,
      lte: 36
    },
    female: {
      gte: 43,
      lte: 165
    },
    detail: {
      i18n_key: 'client:measurement.e2_details',
      text: "-\u5973\u6027 (\u9EC3\u9AD4\u671F)\uFF1A(\u53C3\u8003\u503C 43-145\uFF1B\u7406\u60F3\u503C 60-165)\n\n        -\u5973\u6027 (\u6FFE\u6CE1\u671F)\uFF1A(\u53C3\u8003\u503C 39-332\uFF1B\u7406\u60F3\u503C60-375)\n\n        -\u5973\u6027 (\u505C\u7D93\u5F8C)\uFF1A(\u53C3\u8003\u503C 43-145\uFF1B\u7406\u60F3\u503C 60-165)\n\n        -\u7537\u6027\uFF1A(\u53C3\u8003\u503C 9-36\uFF1B\u7406\u60F3\u503C 15-30)"
    },
    unit: 'pg/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.progesterone',
      text: '黃體脂酮'
    },
    value: 'progesterone',
    male: {
      gte: 0.1,
      lte: 0.7
    },
    female: {
      gte: 4,
      lte: 28
    },
    detail: {
      i18n_key: 'client:measurement.progesterone_details',
      text: "\u5973\u6027 (\u9EC3\u9AD4\u671F)\uFF1A(\u53C3\u8003\u503C 4.0-22\uFF1B\u7406\u60F3\u503C 8.0-28)\n\n                  \u5973\u6027 (\u6FFE\u6CE1\u671F)\uFF1A(\u53C3\u8003\u503C 0.1-1.5\uFF1B\u7406\u60F3\u503C 0.5-2.2)\n\n                  \u5973\u6027 (\u505C\u7D93\u5F8C)\uFF1A2.0-8.0\n\n                  \u7537\u6027\uFF1A(\u53C3\u8003\u503C 0.1-0.5\uFF1B\u7406\u60F3\u503C 0.32-0.7)"
    },
    unit: 'ng/mL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.inflammationIndexBlood',
    text: '發炎指數-血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.crp',
      text: 'C反應性蛋白試驗'
    },
    value: 'crp',
    gte: 0,
    lte: 0.1,
    detail: {
      i18n_key: 'client:measurement.crp_details',
      text: "\u5FC3\u8840\u7BA1\u75BE\u75C5\u98A8\u96AA\u5206\u7D1A\uFF1A\n\n                   Low Risk:<0.100mg/dL\uFF1B \n    Average Risk:0.100-0.300mg/dL\uFF1B \n    High Risk:>0.300mg/dL"
    },
    unit: 'mg/dL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.endocrineAnalysisSpecimenBlood',
    text: '內分泌分析-檢體：血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.testosterone',
      text: '睪固酮'
    },
    value: 'testosterone',
    male: {
      gte: 3,
      lte: 9.8
    },
    female: {
      gte: 0.08,
      lte: 0.8
    },
    detail: {
      i18n_key: 'client:measurement.testosterone_details',
      text: "-\u5973\u6027 (\u9EC3\u9AD4\u671F/\u6FFE\u6CE1\u671F/\u505C\u7D93\u5F8C)\uFF1A\n\n                  (\u53C3\u8003\u503C 0.08-0.6\uFF1B\u7406\u60F3\u503C 0.35-0.8)\n\n                  -\u7537\u6027 >18\u6B72\uFF1A(\u53C3\u8003\u503C 3.0-8.7\uFF1B\u7406\u60F3\u503C 4.6-9.2)\n\n                  -\u7537\u6027<18\u6B72\uFF1A(\u53C3\u8003\u503C 3.0-9.8\uFF1B\u7406\u60F3\u503C 4.6-9.8)"
    },
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.shbg',
      text: '性激素結合蛋白'
    },
    value: 'shbg',
    male: {
      gte: 15,
      lte: 45
    },
    female: {
      gte: 26,
      lte: 118
    },
    detail: {
      i18n_key: 'client:measurement.shbg_details',
      text: "-\u5973\u6027\uFF1A(\u53C3\u8003\u503C 26-118\uFF1B\u7406\u60F3\u503C 49-95)\n\n        -\u7537\u6027\uFF1A(\u53C3\u8003\u503C 15-45\uFF1B\u7406\u60F3\u503C 15-38)"
    },
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.c_peptide',
      text: 'C-胜太胰島素'
    },
    value: 'c_peptide',
    gte: 1.06,
    lte: 2.53,
    detail: "",
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.insulin',
      text: '胰島素分析'
    },
    value: 'insulin',
    gte: 2.6,
    lte: 24.9,
    detail: "",
    unit: 'uU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.insulin_pc_1hr',
      text: '胰島素分析1HRS'
    },
    value: 'insulin_pc_1hr',
    detail: "",
    unit: 'uU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.insulin_pc_2hr',
      text: '胰島素分析2HRS'
    },
    value: 'insulin_pc_2hr',
    detail: "",
    unit: 'uU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.insulinab',
      text: '胰島素抗體'
    },
    value: 'insulinab',
    gte: 0,
    lte: 5.5,
    detail: "(B/T)\n\n                    B=binding\n\n                    T=total count",
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_vitamin_d',
      text: '維生素 D'
    },
    value: 'blood_vitamin_d',
    gte: 30,
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.igf_1',
      text: '胰島素樣生長因子'
    },
    value: 'igf_1',
    gte: 177,
    lte: 385,
    detail: '20-30 yrs：232.00-385.00，30-40 yrs：177.00-382.00 ng/mL',
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.igfbp_3',
      text: '胰島素樣生長因子結合蛋白'
    },
    value: 'igfbp_3',
    lte: 6.6,
    detail: '',
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.b_hcg',
      text: 'β-HCG'
    },
    value: 'b_hcg',
    lte: 5,
    detail: '健康人和未懷孕個體: <5.00 mIU/mL',
    unit: 'mIU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.growth_hormone',
      text: '生長激素'
    },
    value: 'growth_hormone',
    lte: 6.6,
    detail: '成人：<6.60 ng/mL',
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.androstenedione',
      text: '雄二烯酮'
    },
    value: 'androstenedione',
    male: {
      gte: 0.64,
      lte: 2.97
    },
    female: {
      gte: 0.35,
      lte: 2.78
    },
    detail: '男Age:20-67: 0.64-2.97 ; 女Age:19-62: 0.35-2.78 ng/mL',
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.a_ohp_17',
      text: '17-α-羥基孕酮'
    },
    value: 'a_ohp_17',
    lte: 6.6,
    detail: '濾泡期: 0.21-1.45；黃體: 0.61-2.88；男: 0.55-1.99 ng/mL',
    unit: 'ng/mL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.nuclearMedicineExaminationSpecimenBlood',
    text: '核子醫學檢查-檢體：血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.dhea_s',
      text: '脫氫表雄固酮硫酸鹽'
    },
    value: 'dhea_s',
    male: {
      gte: 3.7,
      lte: 400.7
    },
    female: {
      gte: 4.6,
      lte: 285
    },
    detail: {
      i18n_key: 'client:measurement.dhea_s_details',
      text: "\u5973\u6027: \n\n                  <10: 2.90-99.50;\n\n                  10-19: 4.10-167.60;\n\n                  20-29: 20.10-414.20;\n\n                  30-39: 47.80-3360;\n\n                  40-49: 7.6-280.0;\n\n                  50-59: 3.7-242.40;\n\n                  60-69: 3.00-106.90;\n\n                  70-79: 5.7-100:00;\n\n                  80-89: 4.9-72.7;\n\n                  >90: 4.3-54 ug/dL \n \n   \n                  \u7537\u6027: \n\n                  <10: 3.20-83.50;\n\n                  10-19: 5.00-180.60;\n\n                  20-29: 52.10-466.80;\n\n                  30-39: 5.40-457.10;\n\n                  40-49: 32.5-276.9;\n\n                  50-59: 69.6-192;\n\n                  60-69: 3.2-201.8;\n\n                  70-79: 6.3-82.3;\n\n                  80-89: 8.8-173.7 ug/dL"
    },
    unit: 'ug/dl'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_vitamin_b12',
      text: '維他命 B12'
    },
    value: 'blood_vitamin_b12',
    gte: 197,
    lte: 771,
    detail: '',
    unit: 'pg/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_folic_acid',
      text: '葉酸'
    },
    value: 'blood_folic_acid',
    gte: 3.89,
    lte: 26.8,
    detail: '',
    unit: 'ng/mL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.generalBiochemicalExamination',
    text: '一般生化學檢查'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.glycatedalbumin',
      text: '醣化白蛋白'
    },
    value: 'glycatedalbumin',
    gte: 11,
    lte: 16,
    detail: '',
    unit: '%'
  }, {
    title: {
      i18n_key: 'client:measurement.apolib_ai_ratio',
      text: 'ApoB/ApoA1載脂蛋白A、B比值'
    },
    value: 'apolib_ai_ratio',
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.globulin',
      text: 'Glycoalbumin_GA'
    },
    value: 'globulin',
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.albumin',
      text: 'Albumin_GA'
    },
    value: 'albumin',
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.upcr',
      text: '尿蛋白肌酸酐比值'
    },
    value: 'upcr',
    gte: 1.2,
    lte: 8.7,
    detail: {
      i18n_key: 'client:measurement.upcr_details',
      text: "-\u5973\u6027 (\u9EC3\u9AD4\u671F/\u6FFE\u6CE1\u671F)\uFF1A(\u53C3\u8003\u503C 1.2-6.8\uFF1B\u7406\u60F3\u503C 4.2-8.7)\n\n                -\u5973\u6027 (\u505C\u7D93\u5F8C)\uFF1A<0.3"
    },
    unit: ''
  }]
}, {
  title: {
    i18n_key: 'client:measurement.electrolyteAnalysisBlood',
    text: '電解質分析-血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.blood_na',
      text: '鈉離子'
    },
    value: 'blood_na',
    gte: 136,
    lte: 146,
    detail: '',
    unit: 'mEq/L'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_ca',
      text: '血中鈣'
    },
    value: 'blood_ca',
    gte: 8.6,
    lte: 10.3,
    detail: '',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_p',
      text: '血中磷'
    },
    value: 'blood_p',
    gte: 2.5,
    lte: 5.0,
    detail: '',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_k',
      text: '鉀離子'
    },
    value: 'blood_k',
    gte: 3.5,
    lte: 5.1,
    detail: '',
    unit: 'mEq/L'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_cl',
      text: '氯離子'
    },
    value: 'blood_cl',
    gte: 101,
    lte: 109,
    detail: '',
    unit: 'mEq/L'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_zn',
      text: '血中鋅'
    },
    value: 'blood_zn',
    gte: 700,
    lte: 1200,
    detail: '',
    unit: 'ug/L'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_mg',
      text: '鎂離子'
    },
    value: 'blood_mg',
    gte: 1.9,
    lte: 2.7,
    detail: '',
    unit: 'mg/dL'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.ironDeficiencyAnemiaTestBlood',
    text: '缺鐵性貧血檢查 - 血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.blood_iron_tibc',
      text: '總鐵結合能'
    },
    value: 'blood_iron_tibc',
    gte: 240,
    lte: 450,
    detail: '',
    unit: 'ug/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_iron',
      text: '鐵離子'
    },
    value: 'blood_iron',
    gte: 50,
    lte: 212,
    detail: '',
    unit: 'ug/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.ferritin',
      text: '鐵蛋白'
    },
    value: 'ferritin',
    male: {
      gte: 23.9,
      lte: 336.2
    },
    female: {
      gte: 11,
      lte: 306.8
    },
    detail: '',
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.blood_iron_uibc',
      text: '未飽和鐵結合量'
    },
    value: 'blood_iron_uibc',
    gte: 155,
    lte: 355,
    detail: '',
    unit: 'ug/dL'
  }]
}, {
  title: {
    i18n_key: 'client:cardiovascularExaminationBlood',
    text: '心臟血管檢查-血液'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.ldh',
      text: '乳酸脫氫脢'
    },
    value: 'ldh',
    gte: 140,
    lte: 271,
    detail: '',
    unit: 'U/L'
  }, {
    title: {
      i18n_key: 'client:measurement.cpk',
      text: '肌酸磷化激脢'
    },
    value: 'cpk',
    gte: 30,
    lte: 223,
    detail: '',
    unit: 'U/L'
  }]
}, {
  title: {
    i18n_key: 'client:measurement.uncategorizedInspectionItems',
    text: '未分類檢驗項目'
  },
  data: [{
    title: {
      i18n_key: 'client:measurement.amh',
      text: '抗穆勒氏荷爾蒙'
    },
    value: 'amh',
    female: {
      gte: 1.2,
      lte: 8.7
    },
    male: {
      gte: 1.2,
      lte: 8.7
    },
    detail: {
      i18n_key: 'client:measurement.amh_details',
      text: "-\u5973\u6027 (\u9EC3\u9AD4\u671F/\u6FFE\u6CE1\u671F)\uFF1A(\u53C3\u8003\u503C 1.2-6.8\uFF1B\u7406\u60F3\u503C 4.2-8.7)\n\n               -\u5973\u6027 (\u505C\u7D93\u5F8C)\uFF1A<0.3"
    },
    unit: 'ng/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.gad',
      text: '穀醯胺酸脫羧脢抗體'
    },
    value: 'gad',
    detail: "(-):<10.0\uFF1B(+):>=10 IU/mL",
    unit: ' IU/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.ages',
      text: '最終糖化蛋白'
    },
    value: 'ages',
    gte: 0,
    lte: 5,
    detail: '',
    unit: 'U/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.cystatin_c',
      text: '血清胱蛋白'
    },
    value: 'cystatin_c',
    gte: 0.56,
    lte: 1.02,
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.apo_e_genotype',
      text: '脂蛋白E基因型分析'
    },
    value: 'apo_e_genotype',
    detail: '',
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.lpa',
      text: '脂蛋白-A'
    },
    value: 'lpa',
    gte: 0,
    lte: 34,
    detail: '',
    unit: 'mg/dL'
  }, {
    title: {
      i18n_key: 'client:measurement.alp',
      text: '鹼性磷酸酵素'
    },
    value: 'alp',
    gte: 34,
    lte: 104,
    detail: '',
    unit: 'U/L'
  }, {
    title: {
      i18n_key: 'client:measurement.ggt',
      text: '麩胺轉移脢'
    },
    value: 'ggt',
    gte: 9,
    lte: 64,
    detail: '',
    unit: 'U/L'
  }, {
    title: {
      i18n_key: 'client:measurement.ca_199',
      text: 'CA199'
    },
    value: 'ca_199',
    gte: 0,
    lte: 35,
    detail: '',
    unit: 'U/mL'
  }, {
    title: {
      i18n_key: 'client:measurement.pt',
      text: '凝血酶原時間'
    },
    value: 'pt',
    gte: 9.4,
    lte: 12.5,
    detail: {
      i18n_key: 'client:measurement.pt_details',
      text: '危險數據：>40 sec'
    },
    unit: 'sec'
  }, {
    title: {
      i18n_key: 'client:measurement.inr',
      text: 'INR'
    },
    value: 'inr',
    gte: 0.85,
    lte: 1.15,
    detail: {
      i18n_key: 'client:measurement.inr_details',
      text: "INR therapeutic range\uFF1A\n\n                \u975C\u8108\u6813\u585E\u7684\u9810\u9632\u548C\u6CBB\u7642\uFF0C\u80BA\u6813\u585E\u7684\u6CBB\u7642\u5EFA\u8B70\u63A7\u5236\u5728 \n\n                INR\uFF1A2-3 \uFF0C\u6025\u6027\u5FC3\u808C\u6897\u585E\u548C\u63A5\u53D7\u4EBA\u5DE5\u5FC3\u81DF\u74E3\u819C\u624B\u8853\u7684\u75C5\u4EBA\u5EFA\u8B70\u63A7\u5236\u5728 \n\n                INR\uFF1A2.5-3.5"
    },
    unit: ''
  }, {
    title: {
      i18n_key: 'client:measurement.aptt',
      text: '危險數據：>40 sec'
    },
    value: 'aptt',
    gte: 28,
    lte: 40,
    detail: {
      i18n_key: 'client:measurement._details',
      text: '危險數據：≧100 sec'
    },
    unit: 'sec'
  }, {
    title: {
      i18n_key: 'client:measurement.oxldl',
      text: '氧化型脂蛋白'
    },
    value: 'oxldl',
    detail: {
      i18n_key: 'client:measurement.oxldl_details',
      text: "-\u5973\u6027 (\u9EC3\u9AD4\u671F/\u6FFE\u6CE1\u671F)\uFF1A(\u53C3\u8003\u503C 1.2-6.8\uFF1B\u7406\u60F3\u503C 4.2-8.7) \n\n              -\u5973\u6027 (\u505C\u7D93\u5F8C)\uFF1A<0.3"
    },
    unit: ''
  }]
}];

var parseText = function parseText(t, text) {
  return typeof text === 'string' ? text : t(text.i18n_key, text.text, text.vars);
};

export var getMeasurementItems = function getMeasurementItems(t) {
  return MEASUREMENTS.map(function (category) {
    return _objectSpread(_objectSpread({}, category), {}, {
      title: parseText(t, category.title),
      data: category.data.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          title: parseText(t, item.title),
          detail: isNotNil(item.detail) ? parseText(t, item.detail) : undefined
        });
      })
    });
  });
};
export var getMeasurementItemByKey = function getMeasurementItemByKey(key, t) {
  var measurementItems = getMeasurementItems(t);
  var measurementItemData = measurementItems.find(function (item) {
    return item.data.find(function (res) {
      return res.value === key;
    });
  });
  var measurementItem = measurementItemData === null || measurementItemData === void 0 ? void 0 : measurementItemData.data.find(function (res) {
    return res.value === key;
  });
  return measurementItem;
};